import React, { useMemo } from 'react';

import { defineMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';

const DraftYearSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const draftData = useSelector((state) => state.config.draftData);
    // Year can be either number or string (i.e. 20182019 or 'undrafted')
    const selectedYear = useSelector((state) => state.playersAndTeams.filter.values.draftYear);

    const setDraftYear = (e, { value }) => {
        dispatch(filterActionCreators.setDraftYear(value));
    };

    const options = useMemo(() => {
        return [
            {
                value: '',
                label: intl.formatMessage(
                    defineMessage({
                        defaultMessage: 'All Draft Years',
                        description: 'A phrase describing an option that will include all draft years when selected',
                    }),
                ),
                key: 'all',
            },
            {
                value: 'undrafted',
                label: intl.formatMessage(
                    defineMessage({
                        defaultMessage: 'Undrafted',
                        description:
                            'A phrase describing an option that will apply a filter to only include undrafted players',
                    }),
                ),
                key: 'undrafted',
            },
            ...draftData.map(({ draftYear: year }) => ({ value: year, label: `${year}`, key: year })).reverse(),
        ];
    }, [draftData]);

    const selectedOption = useMemo(() => options.find((obj) => obj.value === selectedYear), [options, selectedYear]);

    return (
        <Select
            onOptionChange={setDraftYear}
            options={options}
            selectedOption={selectedOption}
            isSearchEnabled
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(DraftYearSelect);
